// extracted by mini-css-extract-plugin
export default {"spinnerOverlayWrapper":"loading_spinner_spinnerOverlayWrapper__uK6T5","mascotLogo":"loading_spinner_mascotLogo__coGjA","spinnerContainer":"loading_spinner_spinnerContainer__G+ocw"};